import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import {
  Divider,
  Grid,
  Header,
} from 'semantic-ui-react';

import { sidebarLinksTop, sidebarLinksBottom } from '../../utils/nav';
import './style.css';

const links = [...sidebarLinksTop, ...sidebarLinksBottom];

const pageTitleText = (t, pathname) => {
  const pages = links.filter(item => pathname.indexOf(item.pageId) === 0);

  return pages.length === 1
    ? t(pages[0].pageTitle)
    : t('common.welcome');
};

const RouteContent = ({ t, children, location }) => (
  <div className="route-content-container">
    <Grid padded>
      <Grid.Column width="1" />
      <Grid.Column width="14">
        <Header>
          &nbsp;&nbsp;&nbsp;
          {pageTitleText(t, location.pathname)}
        </Header>
        <Divider clearing />
        {children}
      </Grid.Column>
      <Grid.Column width="1" />
    </Grid>
  </div>
);

RouteContent.propTypes = {
  t: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({}).isRequired,
};

export default translate()(RouteContent);



// WEBPACK FOOTER //
// ./src/components/RouteContent/RouteContent.js